import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'apsis-back-office-account-domain-delete',
  templateUrl: './account-domain-delete.component.html',
  styleUrls: ['./account-domain-delete.component.scss'],
})
export class AccountDomainDeleteComponent {
  @Input() accountId: string;
  @Output() delete = new EventEmitter<void>();

  constructor(public readonly activeModal: NgbActiveModal) {}

  confirm() {
    this.activeModal.close();
    this.delete.emit();
  }

  cancel() {
    this.activeModal.close();
  }
}
